export const BASE_URL = process.env.REACT_APP_TMDB_URL;

export const API_KEY = process.env.REACT_APP_TMDB_API_KEY;